export default "/images/icons8-canada.png?65194ade8fa01998f120e75c5fc1841c";